import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Button, Input, Grid, Popup, Form} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {addError, addSuccessMessage} from 'state/actions';

import styles from './BackupCreation.module.scss';

const backupNameValidationRegex = new RegExp('^[a-z0-9]([-a-z0-9-.]*[a-z0-9])?$');

const BackupCreation = ({projectName, siteName, disabled}) => {
  const dispatch = useDispatch();
  const [backupName, setBackupName] = useState('');

  const createBackupHandler = async () => {
    if (backupNameValidationRegex.test(backupName) && backupName !== undefined && !disabled) {
      const {
        data: {message},
      } = await httpClient.post(`/api/drupal/${projectName}/drupalsites/backups`, {
        backupName,
        siteName,
      });
      setBackupName('');
      dispatch(addSuccessMessage(message));
    } else {
      dispatch(addError('The backup name is not valid'));
    }
  };

  return (
    <Form>
      <Grid columns={3} stackable>
        <Grid.Row>
          <Grid.Column textAlign="right" verticalAlign="middle" width={5}>
            <Popup
              content="Name of the backup. The name can contain no more than
              253 characters, only lowercase alphanumeric characters, '.' and '-', and
              start and end with an alphanumeric character"
              position="left center"
              trigger={<label htmlFor="name">Create new backup</label>}
            />
          </Grid.Column>
          <Grid.Column verticalAlign="middle" width={7}>
            <Input
              name="name"
              fluid
              value={backupName}
              placeholder="my-backup"
              onChange={(_evt, data) => {
                setBackupName(data.value);
              }}
            />
          </Grid.Column>
          <Grid.Column verticalAlign="middle" width={4}>
            <Button
              type="submit"
              className={styles.SaveButton}
              onClick={() => {
                createBackupHandler();
              }}
              disabled={
                !backupNameValidationRegex.test(backupName) || backupName === undefined || disabled
              }
            >
              Create
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

BackupCreation.propTypes = {
  projectName: PropTypes.string.isRequired,
  siteName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default BackupCreation;
